<template>
	<view class="coffee">
		<view class="coffee_item" v-for="(item, index) in 3" :key="index" @click="toDetailed">
			<image src="@/static/icon/img_baike@2x.png" mode="widthFix"></image>
			<view class="coffee_item_right">
				<text>澳白Flatwhite</text>
				<text>¥26</text>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			toDetailed() {
				uni.navigateTo({
					url: '/pages/hotDishesDetails/index'
				});
			}
		}
	}
</script>

<style>
	page {
		background-color: #ffffff !important;
	}
</style>

<style lang="scss" scoped>
	.coffee {
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
		.coffee_item {
			margin-bottom: 52rpx;
			display: flex;
			align-items: center;
			image {
				width: 264rpx;
				height: 176rpx;
				flex-shrink: 0;
				margin-right: 20rpx;
				border-radius: 15rpx;
			}
			.coffee_item_right {
				flex: 1;
				height: 176rpx;
				display: flex;
				align-items: flex-start;
				flex-direction: column;
				text {
					&:first-child {
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						display: -webkit-box;
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:last-child {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
						margin-top: 28rpx;
					}
				}
			}
		}
	}
</style>